<template>
  <div id="app">
    <el-container>
      <el-header height="150px"><div class="header">
        <img class="header_logo" src="../../../assets/home/home_purchase/yhyj3_03.png"/>
      </div></el-header>
      <el-main>
        <div class="main">
          <div class="main_shangpin">

            <el-image class="main_shangpin_img"
                      :src="url+'/storage/'+application.pic ">
            </el-image>
            <span class="shanpin_bianhao">订单编号: {{ application.order_no }}
            </span>
            <span class="shanpin_name">{{ application.title }}</span>
            <el-link type="primary" style="position: absolute;margin-top: 55px;margin-left: 20px"
                     :href="'http://api.yi-mix.com/storage/'+application.contract" target="_blank">{{ application.contract }}</el-link>
            <div class="shanpin_jine">￥{{application.pay_price}}</div>

          </div>
          <a @click="is_open.fkfangshi=3">
            <div class="main_yue " :class="is_open.fkfangshi==3?'main_zf_xuanzhong':''">
              <img class="main_zfb_img" v-if="is_open.fkfangshi==3?'main_zf_xuanzhong':''"
                   src="../../../assets/home/home_purchase/d41a5a59975a4a94fe5398381173b0d.png"/>
              <img class="main_img" src="../../../assets/home/home_purchase/yue.png"/>
              <div class="zf_text">余额支付
                <div class="zf_text2">余额付 更便捷</div>
              </div>
            </div>
          </a>
          <a @click="is_open.fkfangshi=1">
          <div class="main_zfb " :class="is_open.fkfangshi==1?'main_zf_xuanzhong':''">
            <img class="main_zfb_img" v-if="is_open.fkfangshi==1?'main_zf_xuanzhong':''" src="../../../assets/home/home_purchase/d41a5a59975a4a94fe5398381173b0d.png" />
            <img class="main_img" src="../../../assets/home/home_purchase/yhyj3_07.png" />
            <div class="zf_text">支付宝
              <div class="zf_text2">支付宝 知托付</div></div>

          </div>
          </a>
          <a @click="is_open.fkfangshi=0">
          <div class="main_weixin" :class="is_open.fkfangshi==0?'main_zf_xuanzhong':''">
            <img class="main_zfb_img" v-if="is_open.fkfangshi==0?'main_zf_xuanzhong':''" src="../../../assets/home/home_purchase/d41a5a59975a4a94fe5398381173b0d.png" />
            <img class="main_img" src="../../../assets/home/home_purchase/yhyj3_10.png" />
            <div class="zf_text" >微信
              <div class="zf_text2">付于心 诚于信</div></div>

          </div>
          </a>
          <div class="main_zf_butt">
<!--            <a target="_blank" :href="is_open.fkfangshi==0 ? '#/wechat/pay/application/'+order_id : url+'/user/application/order/alipay?token='+token+'&order_id='+order_id">-->
            <template v-if="is_open.fkfangshi ==1">
            <a target="_blank" :href="pay_url">
            <div class="anniu_1">
              去支付宝付款
            </div>
            </a>
            </template>
            <template v-if="is_open.fkfangshi ==0">
              <a target="_blank" :href="pay_url">
                <div class="anniu_1">
                  去微信付款
                </div>
              </a>
            </template>
            <template v-if="is_open.fkfangshi ==3">
            <a target="_blank" :href="pay_url">
              <div class="anniu_1">
                去余额付款
              </div>
            </a>
          </template>
            <div class="anniu_2">
              取消
            </div>
          </div>

        </div>
        <div style="width: 100%;height: 200px"></div>
      </el-main>
      <el-footer height="250px">
        <el-row class="footer footer_bottom">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="footer_width">
              <div class="glzy_top">
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_gyyyj_left">关于仪海仪家</span>
                </a>
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_lxwm_left">联系我们</span>
                </a>
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_lxwm_left">著作权与商标声明</span>
                </a>
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_lxwm_left">隐私政策</span>
                </a>
              </div>
              <div class="glzy_bottom">
                <span class="footer_text2 ">
                  Copyright@2020 海粟智链（青岛）科技有限公司
                  版权所有鲁ICP备 19060515号-1</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import { regionDataPlus, CodeToText} from "element-china-area-data"
import QRCode from "qrcodejs2";
export default {
  name: 'App',
  data:function(){
    return{
      is_open:{
        sousuo:1,
        lanmu:1,
        fkfangshi:'1',
      },
      radio:'1',
      textarea:'',
      options: regionDataPlus,
      diqu:'',
      xiangxi:'',
      list:'',
      shuliang:'',
      zfb_url:'',
      url:'',
        token:'',
      order_id:'',
      pay_status:'',
      fukuan_shijian:false,
      application: {
          pic:''
      },
    }
  },
    computed:{
        pay_url:function( ){
            let wechat_pay_url = '#/wechat/pay/application/'+ this.order_id;
            let balance_application = '#/balance_application/'+this.order_id;
            let application_detail_url = window.config.yihai_site
                + '/home.html#/college/programme/'
                + this.application.application_program_id;
            let alipay_url = this.url+'/user/application/order/alipay?'
                + 'token=' + this.token
                + '&order_id=' + this.order_id
                + '&return_url=' + encodeURIComponent( application_detail_url )
            ;
            // return this.is_open.fkfangshi==0 ? wechat_pay_url : alipay_url;
             if (this.is_open.fkfangshi==0){
                 return wechat_pay_url;
             } else if(this.is_open.fkfangshi==1){
                 return alipay_url;
             }else {
                 return balance_application;
             }
        },

    },
  methods:{
    init(){
      this.token = localStorage.getItem("token")
      this.url = window.config.api_url
      var t = this
      t.order_id = t.$route.params.order_id
      if (t.order_id){
        t.xinxi()
      }else{
        this.$message({
          message: '应用方案订单不存在',
          type: 'error',
        });
      }
    },
    xinxi(){
      var t = this
      var token = localStorage.getItem('token')
      var url = window.config.api_url+'/user/application/order/'+t.order_id+'?token='+token
      t.axios.get(url).then(res=>{
        t.application = res.data
      })
    },
    qrCode() {
      var wx_url = ''
      var t = this
      var id = localStorage.getItem("uid")
      var url = window.config.api_url+'/user/goods/order/wechatPay?token='+id+'&order_id='+t.$route.params.id
      t.axios.get(url).then(res=>{
        console.log(res.data)
        if (res.data.code_url){
          wx_url = res.data.code_url
          t.erweima(wx_url)
        }
      })

    },
    erweima(wx_url){
      this.dialogVisible = true;
      // console.log(this.radio,this.radio1)
      var qrcode = ''
      console.log(qrcode)
      this.$nextTick(function () {
        document.getElementById("qrcode").innerHTML = "";
        qrcode = new QRCode("qrcode", {
          width: 150,
          height: 150,
          text: wx_url,
          colorDark: "#000000",
          colorLight: "#ffffff"
        });
      });
    },
    api_data(){
      this.shuliang = this.$store.state.pathName
      var t = this
      var id = localStorage.getItem("uid")
      var url = window.config.api_url+'/user/goods/order/'+t.$route.params.id+'?token='+id
      t.axios.get(url).then(res=>{
        // console.log(res.data)
        t.pay_status = res.data.order.pay_status
        if (res.data.order.pay_status!=1){
          t.open4()
        }
      })
    },
    open4() {
      this.$message.error('付款失败');
    },
    sousuo_xuanxiang(e){
      this.is_open.sousuo = e
      // console.log(this.is_open.sousuo)
    },
    handleChange(){
      // console.log(CodeToText[e[0]])
      // console.log(CodeToText[e[1]])
    },
    click(){
      // 点击按钮进行一些操作，然后保存数据
      this.$store.commit('saveCurrDbSource',2)
      console.log(
          this.$store.state.currDbSource)
    },
    posy(){
      var t = this
      var url = window.config.api_url+'/user/goodsOrder/create'
      var formData = new FormData();
      var id = 'deTqiWkXIJSUn1OLRkV5jmHTCIjtR3JpTnAyKjcsZ3jUEq9XXonVruQ6pCR3'
      // localStorage.getItem("uid")
      formData.append('token', id);
      formData.append('detail_address', t.xiangxi);
      formData.append('note', t.textarea);
      formData.append('province_code', t.diqu[0]);//省代码
      formData.append('province', CodeToText[t.diqu[0]]);
      formData.append('city_code', t.diqu[1]);//市代码
      formData.append('city', CodeToText[t.diqu[1]]);
      formData.append('area_code', t.diqu[2]);//区代码
      formData.append('area', CodeToText[t.diqu[2]]);
      formData.append('goods[0][goods_id]', 95);
      formData.append('goods[0][number]', 1);
      t.axios.post(url,formData).then(res=>{
        console.log(res)
      })
    }

  },
  created() {
    this.init()
  }
}
</script>
<style lang="less" scoped>
@import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";
//@head_text : Source Han Sans CN;
@font-face {

}
@import "../../../assets/css/home";
.el-footer {
  background-color: #FFFFFF;
  color: #333;
  //text-align: center;
  padding: 0 0;
  //line-height: 60px;
}

.el-main {
  background-color: #FFFFFF;
  color: #333;
  //text-align: center;
  padding: 0 0;
  //line-height: 500px;
}

.el-header {
  background: #FFFFFF;
  padding: 0 0;
  //border-bottom: #4E6EF2 solid 3px;
}

#app {
  width: 100%;
  .header{
    height: 100%;
    width: 80%;
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;
    .header_logo{
      margin-top: 50px;
    }
  }
  .main{
    height: 100%;
    width: 80%;
    //height: 200px;
    max-width: 1200px;
    margin-bottom: 122px;
    margin-right: auto;
    margin-left: auto;
    .main_shangpin{
      height: 86px;
      position: relative;
      .main_shangpin_img{
        width: 85px;
        height: 85px;
        background: #FFFFFF;
        border: 1px solid #E1E1E1;
      }
      .shanpin_bianhao{
        position: absolute;
        margin-left: 20px;
        //width: 209px;
        //height: 14px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        //line-height: 100px;
      }
      .shanpin_name{
        margin-left: 20px;
        position: absolute;
        margin-top: 28px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
      }
      .shanpin_jine{
        //width: 175px;
        //height: 36px;
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #EF4F3F;
        //line-height: 100px;
        float: right;
      }
      .shangpin_daojishi{
        //width: 182px;
        //height: 14px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
        float: right;
        //width: 70%;
        //line-height: 100px;
      }
      .shangpin_daojishi2{
        color: #EF4F3F;
      }
    }
    .main_zfb_img{
      float: right;
    }
    .main_img{
      float: left;
      margin-left: 37px;
      margin-top: 25px;
    }
    .zf_text{
      margin-top: 20px;
      margin-left: 20px;
      float: left;
      width: 90px;
      //width: 58px;
      //height: 19px;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      //line-height: 100px;
    }
    .zf_text2{
      //width: 87px;
      //height: 14px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      //line-height: 100px;
    }
    .main_zfb{
      width: 100%;
      height: 100px;
      background: #FFFFFF;
      border: 1px solid #D1D1D1;
      border-radius: 13px;
      margin-top: 20px;
      position: relative;

    }
    .main_yue{
      width: 100%;
      height: 100px;
      background: #FFFFFF;
      border: 1px solid #D1D1D1;
      border-radius: 13px;
      margin-top: 100px;
      position: relative;
    }
    .main_weixin{
      width: 100%;
      height: 100px;
      background: #FFFFFF;
      border: 1px solid #D1D1D1;
      border-radius: 13px;
      margin-top: 20px;
      position: relative;
    }
    .main_zf_xuanzhong{
      border: 1px solid #4E6EF2;
    }
    .main_zf_butt{
      margin-top: 120px;
      //margin-bottom: 122px;
      .anniu_1{
        float: right;
        width: 196px;
        height: 60px;
        background: #EF4F3F;
        border-radius: 5px;
        text-align: center;
        line-height: 60px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #FFFFFF;
      }
      .anniu_2{
        margin-right: 20px;
        float: right;
        width: 196px;
        height: 60px;
        background: #D1D1D1;
        border-radius: 5px;
        text-align: center;
        line-height: 60px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #FFFFFF;
      }
    }
  }

  .footer {
    width: 100%;
    height: 255px;
    background: #FFFFFF;
    border-bottom: #E1E1E1 solid 1px;

    .footer_width {
      width: 80%;
      max-width: 1200px;
      margin-right: auto;
      margin-left: auto;

      .xdsk_top {
        position: relative;
        margin-top: 70px;

        .footer_img_xinshou {
          //margin-left: 5px;
          //margin-top: 13px;
          position: absolute;
          width: 50px;
          height: 50px;
        }

        .footer_img_duiwai {
          //margin-left: 155px;
          //margin-top: 13px;
          //margin-top: 13px;
          position: absolute;
          width: 50px;
          height: 50px;
        }

        .footer_img_shiming {
          //margin-left: 155px;
          //margin-top: 13px;
          position: absolute;
          width: 50px;
          height: 50px;
        }

        .footer_img_kefu {
          //margin-left: 155px;
          //margin-top: 13px;
          position: absolute;
          width: 50px;
          height: 50px;
        }

        .footer_xinshou_left {
          margin-left: 60px;
        }

        .footer_dsk_left {
          margin-left: 60px;
        }
      }

      .xdsk_bottom {
        margin-top: 38px;

        .footer_kongjian_left {
          margin-left: 17px;
        }

        .footer_jiaoyi_left {
          margin-left: 184px;
        }

        .footer_shiming_left {
        }

        .footer_tousu_left {
          margin-left: 520px;
        }

        .footer_changjian_left {
          margin-left: 945px;
        }
      }

      .glzy_top {
        margin-top: 51px;

        .footer_gyyyj_left {
          padding-right: 20px;
          border-right: #E1E1E1 solid 1px;
        }

        .footer_lxwm_left {
          margin-left: 29px;
          padding-right: 21px;
          border-right: #E1E1E1 solid 1px;
        }
      }

      .glzy_bottom {
        margin-top: 45px;
      }
    }
  }
  .footer_bottom {
    border-bottom: none;
    height: 223px;
  }
}
.youfudong{
  float: right;
}
.main_text{
  //width: 69px;
  //height: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #666666;
  //line-height: 100px;
}
.main_text1{
  //width: 108px;
  //height: 12px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  //line-height: 100px;
}
.head_text {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 550;
  color: #333333;
  line-height: 38px;
}

.footer_text1 {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 150;
  color: #666666;
  //line-height: 30px;
}

.footer_text2 {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  //line-height: 30px;
}

.footer_text3 {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 550;
  color: #333333;
  //line-height: 30px;
}

.xuanzhong:hover {
  //color:#4E6EF2;
  text-decoration:none;
}
.wenzi{
  text-decoration:none;
}
</style>